import create, { GetState, SetState, StoreApi } from 'zustand';
import { removeTokens } from 'utils/token-utils';
import { createAuthSlice, IAuthSlice } from './createAuthSlice';

export interface IStore {
  auth: IAuthSlice;
  reset: () => void;
  logout: () => void;
}

/**
 * Make sure to enforce type for each slice
 */

const useStore = create<IStore>((set, get, api) => ({
  auth: {
    ...createAuthSlice(
      set as unknown as SetState<IAuthSlice>,
      get as unknown as GetState<IAuthSlice>,
      api as unknown as StoreApi<IAuthSlice>,
    ),
  },
  reset() {
    get().auth.reset();
  },
  logout() {
    removeTokens();
    get().reset();
  },
}));

export default useStore;
